export const LOADING = 'loading'
export const SUCCESS = 'success'
export const IDLE = 'idle'
export const ERROR = 'error'
